import {Radio, Select} from "antd";
import {useProject} from "../Context/ProjectContext";
import {useEffect} from "react";


export default function CrossSectionFilter({csList = [], type}) {
    const {filter, setFilter, internalSelectedId, comparisonBaseId, comparisonCmpId, projectHistory} = useProject()

    const getFilter = () => {
        let _filter = {}
        if(type === 'check') {
            _filter = {...filter.check, filterType: filter.filterType}
        }
        else if(type === 'comparison') {
            _filter = {...filter.comparison, filterType: filter.filterType}
        }
        else if(type === 'clear') {
            _filter = {ds: null, us: null, filterType: filter.filterType}
        }
        return _filter
    }

    useEffect(() => {
        if(!csList || csList.length === 0)
            return
        if(type === 'check') {

        }
        else if(type === 'comparison') {

        }
    }, [csList])

    const getFilterHistory = () => {
        let history = null
        if(type === 'check') {
            history = projectHistory.find(x => x.id === internalSelectedId)
        }
        else {
            history = projectHistory.find(x => x.id === `${comparisonBaseId}-${comparisonCmpId}`)
        }

        if(history) {
            return history.filter;
        }
    }

    useEffect(() => {
        if(!internalSelectedId) {
            setFilter({
                filter: {ds: null, us: null},
                type: 'check',
                filterType: filter.filterType
            })
        }

        if(!comparisonCmpId) {
            setFilter({
                filter: {ds: null, us: null},
                type: 'comparison',
                filterType: filter.filterType
            })
        }

    }, [internalSelectedId, comparisonBaseId, comparisonCmpId])

    const setFilterState = ({filterType, ds, us}) => {
        if(type === 'check') {
            setFilter({
                id: internalSelectedId,
                filter: {ds, us},
                type,
                filterType
            })
        }
        else if(type === 'comparison') {
            setFilter({
                id: `${comparisonBaseId}-${comparisonCmpId}`,
                filter: {ds, us},
                type,
                filterType
            })
        }
    }

    const renderCSList = (cs_list) => {
        return (cs_list || [])?.map(x => (
            <Select.Option key={x.name} value={x.name}>
                {x.name}
            </Select.Option>
        ))
    }

    useEffect(() => {

    }, [])

    return (
        <div style={{flex: 1, display: 'flex', alignItems: 'center', gap: 8}}>
            <Select
                placeholder={'DS'}
                style={{minWidth: 150}}
                size={'small'}
                value={getFilter().ds}
                onChange={(val) => {
                    const _filter = getFilter();
                    if(_filter.us && parseFloat(val) > parseFloat(getFilter().us)) {
                        setFilterState({
                            ...getFilter(),
                            filterType: 'filter',
                            ds: val,
                            us: null
                        })
                    }
                    else {
                        setFilterState({
                            ...getFilter(),
                            filterType: 'filter',
                            ds: val
                        })
                    }
                }}
            >
                {renderCSList([...csList].filter((x,idx) => idx > 0)).reverse()}
            </Select>
            <Select
                placeholder={'US'}
                style={{minWidth: 150}}
                size={'small'}
                value={getFilter().us}
                onChange={(val) => {
                    setFilterState({
                        ...getFilter(),
                        filterType: 'filter',
                        us: val
                    })
                }}
            >
                {
                    renderCSList([...csList].filter(x => {
                        const _filter = getFilter();
                        return (_filter.ds && parseFloat(_filter.ds) < parseFloat(x.name)) || !_filter.ds
                    }))
                }
            </Select>
            <Radio.Group
                options={[
                    {label: 'Color', value: 'highlight'},
                    {label: 'Filter', value: 'filter'},
                    {label: 'Clear', value: 'clear'},
                ]}
                onChange={(e) => {
                    if(e.target.value === 'clear') {
                        setFilterState({
                            ...getFilter(),
                            us: null,
                            ds: null,
                            filterType: e.target.value
                        })
                        return
                    }
                    setFilterState({
                        ...getFilter(),
                        filterType: e.target.value
                    })
                }}
                value={getFilter().filterType}
                optionType="button"
                buttonStyle="solid"
                size={'small'}
            />
        </div>
    )
}